import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import Select from 'react-select';
import '../../prelogin/public/css/react-select.css';
import $ from 'jquery';

class Contactus extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				contact_type: '',
				contact_emailid: '',
				contact_phone: '',
				contact_city: '',
				contact_message: '',	
				contact_userid:"",
				submitButtonDisabled: false,
				serverMessage: "",
				selectedContactOption: null,
				cityVisible:"",
				userIdVisible:false,
				emailIdVisible:true,
				phoneVisible:true,
				defaultSelect:0
		};
		
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.contactTypeDropdownChange = this.contactTypeDropdownChange.bind(this);
		
		this.contactTypeDpList = [];		
		//this.selectedContactOption = null;		
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		let me=this;
		let defaultSelect = 0;
		let resetChoice = false;
		resetChoice = nextProps.resetChoice || false;
		defaultSelect = nextProps.defaultSelect || 0;
		if(resetChoice){
			this.setState({defaultSelect:defaultSelect,serverMessage:"",contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""},()=>{
				me.populateContactDropdown()
			});
		}else{
			this.setState({serverMessage:"",contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});
		}
	}

	componentDidMount(){
		//console.warn("componentDidMount contactus");
		let defaultSelect = this.props.defaultSelect || 0;
		let me=this;
		this.sessionCheck();
		this.setState({defaultSelect:defaultSelect},()=>{
			me.populateContactDropdown();
		});	
	} 


	handleChange(e) {
		const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}

	
	hmNav = function(){		
		//this.props.myProps.history.push(this.props.navigateURL);
		window.top.location.href = this.props.navigateURL;
	}
	
	submitForm = function(){
		var me =this;
		if(this.state.selectedContactOption.value == 2){
			this.submitLumosContactForm();
			return;
		}
		$(".contactus .server-messages").removeClass("success");
		var formData = {				
				"loginId" : (this.state.contact_userid == "") ? null : this.state.contact_userid,
				"emailId" : (this.state.contact_emailid == "") ? null : this.state.contact_emailid,
				"messageType" : this.state.selectedContactOption.label,
				"phoneNo" : (this.state.contact_phone == "") ? null : this.state.contact_phone,
				"message" : (this.state.contact_message == "") ? null : this.state.contact_message,
				"city" : (this.state.contact_city == "") ? null : this.state.contact_city,
				"pageSource" : "prelogin"
		}
		
		me.setState({submitButtonDisabled:true});

		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status.toLowerCase() == "success"){		
					$(".contactus .server-messages").addClass("success");
					me.setState({submitButtonDisabled:true});
					//me.setState({serverMessage:me.rb("contactus.success")+" <br/>"+me.rb("reference_id")+" : "+ response.reference_id});
					 me.props.successContactus(me.rb("contactus.success")+" <br/> <span class='hm-blue'>"+me.rb("reference_id")+" : "+ response.reference_id+"</span>");
				}else if(response.status.toLowerCase() == "user_invalid"){	
					me.setState({serverMessage:me.rb("contactus.invaliduserid"),submitButtonDisabled:false});
				}
				else{
					me.setState({serverMessage:me.rb("error.oops"),submitButtonDisabled:false});				
				}
			}
			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CONTACT_US");		
			me.setState({submitButtonDisabled:false});
		}

		new HmAjax(this.getUrlFor("CONTACT_US"),formData).post(callBackSuccess,callBackFailure);
	}
	submitLumosContactForm = function(){
		var me =this;
		$(".contactus .server-messages").removeClass("success");
		var formData = {				
				"userId" : this.state.contact_userid,
				"name" : this.state.contact_userid,
				"email" : this.state.contact_emailid,
				"subject" : this.state.selectedContactOption.label,
				"message" : this.state.contact_message
		}		

		me.setState({submitButtonDisabled:true});
		
		$.ajax({
	            url: me.getUrlFor("LUMOS_CONTACT_US"),
	            data: formData,
	            type: 'POST',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			 switch (response.code) {
						 case 200:
				           $(".contactus .server-messages").addClass("success");
				           //me.setState({serverMessage:me.rb("contactus.success")});
				           me.setState({submitButtonDisabled:true});
				           me.props.successContactus(me.rb("contactus.success"));
				            break;
				          default:
				            me.setState({serverMessage:response.message,submitButtonDisabled:false});
			          }
	    		},
	            error: function(response){
	    			console.log("Error in lumos login",response);
	    			me.setState({submitButtonDisabled:false});
	    		}
	    });
		
	}
	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.submitForm();    
		}
	}
	
	populateContactDropdown() {    
		let defaultSelect =  this.state.defaultSelect;
		this.contactTypeDpList = [];
		this.contactTypeDpList.push({"label":this.rb("contactus.dropdown1"),"value":1});
		this.contactTypeDpList.push({"label":this.rb("contactus.dropdown2"),"value":2});
		this.contactTypeDpList.push({"label":this.rb("contactus.dropdown3"),"value":3});
		this.contactTypeDpList.push({"label":this.rb("contactus.dropdown5"),"value":4});
		this.setState({selectedContactOption:this.contactTypeDpList[defaultSelect]});
		this.contactTypeDropdownChange(this.contactTypeDpList[defaultSelect]);
	}
		
	contactTypeDropdownChange(selectedOption){
		//console.warn("contactTypeDropdownChange ",selectedOption);
		var me = this;
		let choice = selectedOption.value;
    	this.setState({selectedContactOption:selectedOption,serverMessage:"",cityVisible:"hidden",userIdVisible:false,emailIdVisible:false,phoneVisible:false,contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});
    	
    	if(choice == 1){
    		this.setState({selectedContactOption:selectedOption,cityVisible:"",emailIdVisible:true,phoneVisible:true});
    	}
    	else if(choice == 2){
    		this.setState({selectedContactOption:selectedOption,emailIdVisible:true,userIdVisible:true,phoneVisible:false});
    	}
    	else if(choice == 3){
    		this.setState({selectedContactOption:selectedOption,emailIdVisible:false,userIdVisible:true,phoneVisible:true});
		}
		else if(choice == 4){
    		this.setState({selectedContactOption:selectedOption,cityVisible:"",emailIdVisible:true,phoneVisible:true});
    	}
	}
	render() {
		 return (
				<div id="loginRoot" className="plpLogin contactus">
								
				<div className="container">
				
				<div className="row">
				<div className="col-md-12">

				<div className="row">
				<div className="col-md-12 mx-auto">
				<div className="rounded-0">

				<div className="text-center ">
				
				<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleSubmit} noValidate>
				
				<Select	
					value={this.state.selectedContactOption}
			        onChange={this.contactTypeDropdownChange}
			        options={this.contactTypeDpList}
				 	onBlurResetsInput={false}
					onSelectResetsInput={false}		
				 	clearable={false}
				 	rtl={false}
				 	searchable={false}	
					tabIndex="1"
			      />
				
				
				{(() => {
					if(this.state.userIdVisible == true){
						return(
							<FormGroup for="contact_userid">
								<FormControlInput type="contact_userid" className="contact_userid" name="contact_userid" placeholder={this.rb("login.userid")}					
								value={this.state.contact_userid} onChange={this.handleChange}	
								required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>		
								<FieldFeedbacks for="contact_userid">
									<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>				
								</FieldFeedbacks>	
							</FormGroup>				
						);
					}
				})()}
				
				
				{(() => {
					if(this.state.emailIdVisible == true){
						return(
							<FormGroup for="contact_emailid">
								<FormControlInput type="contact_emailid" className="contact_emailid" name="contact_emailid" placeholder={this.rb("fpwd.email")}
									innerRef={email => this.email = email}
								value={this.state.contact_emailid} onChange={this.handleChange}	
								required maxLength={254} pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$" autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
								
								<FieldFeedbacks for="contact_emailid">
									<FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
									<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
								</FieldFeedbacks>					
							</FormGroup>
						);
					}
				})()}
				
				
				{(() => {
					if(this.state.phoneVisible == true){
						return(
							<FormGroup for="contact_phone">
								<FormControlInput type="contact_phone" className="contact_phone" name="contact_phone" placeholder={this.rb("contactus.phoneno")}
								innerRef={phone => this.phone = phone}	
								value={this.state.contact_phone} onChange={this.handleChange}	
								pattern=".{10,}" maxLength={20} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
									<FieldFeedbacks for="contact_phone">		
										<FieldFeedback when="valueMissing">{this.rb("register.mobilerequired")}</FieldFeedback>
										<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
										 <FieldFeedback when={value => (value.length>0 && !/\d/.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
						);
					}
				})()}
				
				
				
				
				<FormGroup for="contact_city" className={this.state.cityVisible}>
					<FormControlInput type="contact_city" className="contact_city" name="contact_city" placeholder={this.rb("contactus.city")}					
					value={this.state.contact_city} onChange={this.handleChange}	
					maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
				</FormGroup>
				
				<FormGroup for="contact_message">
					<textarea type="contact_message" className="contact_message" name="contact_message" placeholder={this.rb("contactus.message")}
					value={this.state.contact_message} onChange={this.handleChange}	
					required maxLength={3500} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5"/>
					
					<FieldFeedbacks for="contact_message">
						<FieldFeedback when="valueMissing">{this.rb("contactus.messagerequired")}</FieldFeedback>				
					</FieldFeedbacks>					
				</FormGroup>
				
				<div className="clear clearfix"></div>
			
				
				<div className="server-messages">{ReactHtmlParser(this.state.serverMessage)}</div>
				
				<button data-ga="Footer - Contact Us - Send" disabled={this.state.submitButtonDisabled} className="submitButton signup">{this.rb("login.send")}</button>
				</FormWithConstraints>	
				</div>
				</div>
				</div>


				</div>

				</div>
				</div>
				
				
				</div>
				
				<br/>
			
			
				</div>
		);
	}
}

export default Contactus;



// WEBPACK FOOTER //
// ./src/views/login/Contactus.js